import React, { useState } from "react"
import { Box, Typography, IconButton, Stack, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"
import { ManageMeetingDisplayDialog } from "./ManageMeetingDisplayDialog"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { UserMeetingsReceipt } from "../../../../../nonAdminUser/reports/MeetingsReceipt/UserMeetingsReceipt"
import { MeetingDetailsOrder } from "../../meetings/meetingTypes"
import { ServiceCenterBooking } from "../../serviceCenterHomeTypes"

const useStyles = makeStyles()(() => ({
    header: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
    },
    title: {
        fontWeight: "bold",
        fontSize: "1.5rem",
    },
    orderId: {
        verticalAlign: "baseline",
        color: tailwindPalette.slate[500],
        marginLeft: "0.5rem",
    },
    actionButton: {
        width: "2rem",
        height: "2rem",
        color: "black",
        borderRadius: "0.75rem",
        border: `1px solid ${tailwindPalette.slate["300"]}`,
    },
}))

type MeetingHeaderProps = {
    orderId?: number
    meetingData?: MeetingDetailsOrder
    meetings?: ServiceCenterBooking[]
}

export const MeetingHeader: React.FC<MeetingHeaderProps> = ({ meetingData, meetings, orderId }) => {
    const { classes } = useStyles()
    const meetingName = meetingData?.meetingDetails.meetingName
    const meetingId = meetingData?.id

    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [showReceiptModal, setShowReceiptModal] = useState(false)
    const [isManageMeetingOpen, setMeetingOpen] = useState(false)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
        setOpen(true)
    }

    const handleClose = () => setOpen(false)

    const handleReceiptClick = () => {
        setShowReceiptModal(true)
        handleClose()
    }

    const handleMeetingManageClick = () => {
        setMeetingOpen(true)
        handleClose()
    }

    return (
        <Box className={classes.header}>
            <Box>
                <Typography variant="h5" component="h1" className={classes.title}>
                    {meetingName}
                    <Typography component="span" className={classes.orderId}>
                        #{orderId}
                    </Typography>
                </Typography>
            </Box>
            <Stack direction="row" spacing=".5rem">
                <IconButton className={classes.actionButton} size="small" onClick={handleClick}>
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                </IconButton>
            </Stack>

            <ManageMeetingDisplayDialog
                isOpen={isManageMeetingOpen}
                orderId={orderId}
                meetingName={meetingName}
                handleClose={() => setMeetingOpen(false)}
            />

            {showReceiptModal && meetingData && (
                <UserMeetingsReceipt
                    id={meetingId}
                    open={showReceiptModal}
                    meetings={meetings}
                    onClose={() => setShowReceiptModal(false)}
                />
            )}
            <Menu
                anchorEl={anchorEl}
                disableScrollLock
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem onClick={handleMeetingManageClick}>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display">
                        <>Manage meeting display</>
                    </LocalizedStrict>
                </MenuItem>
                <MenuItem onClick={handleReceiptClick}>Show receipt</MenuItem>
            </Menu>
        </Box>
    )
}
